export const SITE = {
    name: "GTECH",
    tagline: "Soluções Eletrônicas",
    whatsappNumber: "5511947414801",
    phoneDisplay: "+55 (11) 94741-4801",
};

export const waLink = (msg) =>
    `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(msg)}`;

export const WA_DEFAULT = waLink(
    "Olá! Quero um orçamento para CFTV / controle de acesso. Podemos conversar?",
);

export const goTo = (e, hash) => {
    e.preventDefault();
    const el = document.querySelector(hash);
    if (!el) return;
    if (window.__lenis) {
        window.__lenis.scrollTo(el, { offset: -84, duration: 1.15 });
    } else {
        el.scrollIntoView({ behavior: "smooth" });
    }
};

export const IMAGES = {
    heroCamera:
        "https://images.unsplash.com/photo-1589935447067-5531094415d1?crop=entropy&cs=srgb&fm=jpg&q=85&w=1800",
    wallCameras:
        "https://images.unsplash.com/photo-1496368077930-c1e31b4e5b44?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    facialAccess:
        "https://images.unsplash.com/photo-1570376332131-1e83730225d6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    facialDevice:
        "https://images.unsplash.com/photo-1776329255945-15212b50cd7f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    technician:
        "https://images.unsplash.com/photo-1555020367-cfc90503032f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    condo:
        "https://images.unsplash.com/photo-1515263487990-61b07816b324?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    cameraPole:
        "https://images.unsplash.com/photo-1618482914248-29272d021005?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    cameraLineup:
        "https://images.unsplash.com/photo-1557597774-9d273605dfa9?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
